<template>
  <HeroComponent />
  <router-view />
  <FooterComponent />
</template>

<script>
import HeroComponent from "../src/components/HeroComponent.vue";
import FooterComponent from "../src/components/FooterComponent.vue";

export default {
  name: "App",
  components: {
    HeroComponent,
    FooterComponent,
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
